module.exports = __webpack_public_path__ + "img/logo-makita-be.33bf7758.jpg";